var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.$ifreamUrl + '/model',"frameborder":"0"}}),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"410px","bottom":"10px","z-index":"99"}},[_c('el-button',{attrs:{"type":"info"},on:{"click":_vm.reload}},[_vm._v("重新开始")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45cad78b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webGl/index.vue
// module id = null
// module chunks = 